(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["si-amazon-routing"] && !Shopify.designMode) return;
  try {
    (() => {
    const marketNames = { uk: 'Amazon UK', de: 'Amazon Germany', us: 'Amazon US' };

    const initialize = () => {
      document.querySelectorAll('[data-si-amazon-routing]').forEach((root) => {
        if (root.dataset.initialized === 'true') return;
        root.dataset.initialized = 'true';

        const routingNode = root.querySelector('[data-amazon-routing]');
        const variantsNode = root.querySelector('[data-amazon-variants]');
        const link = root.querySelector('[data-amazon-link]');
        const status = root.querySelector('[data-amazon-status]');
        const marketButtons = [...root.querySelectorAll('[data-market]')];
        const section = root.closest('.product__section') || document;

        let routing;
        let variants;

        try {
          routing = JSON.parse(routingNode.textContent);
          variants = JSON.parse(variantsNode.textContent);
        } catch (error) {
          link.classList.add('is-disabled');
          link.setAttribute('aria-disabled', 'true');
          status.textContent = 'Amazon links are currently unavailable.';
          return;
        }

        let market = root.dataset.defaultMarket || 'uk';

        try {
          market = window.sessionStorage.getItem('si-amazon-market') || market;
        } catch (error) {
          market = root.dataset.defaultMarket || 'uk';
        }

        const selectedVariant = () => {
          const input = section.querySelector('.product__form-buttons .formVariantId, form[data-product-form] .formVariantId');
          const id = input && input.value;
          return variants.find((variant) => String(variant.id) === String(id)) || variants[0];
        };

        const update = () => {
          const variant = selectedVariant();
          const links = variant ? routing[variant.sku] : null;
          const url = links ? links[market] : null;

          marketButtons.forEach((button) => {
            const isCurrent = button.dataset.market === market;
            const isAvailable = Boolean(links && links[button.dataset.market]);

            button.disabled = !isAvailable;
            button.setAttribute('aria-pressed', String(isCurrent));
          });

          if (url) {
            link.href = url;
            link.classList.remove('is-disabled');
            link.removeAttribute('aria-disabled');
            status.textContent = variant.title + ' will open in ' + marketNames[market] + '.';
          } else {
            link.removeAttribute('href');
            link.classList.add('is-disabled');
            link.setAttribute('aria-disabled', 'true');
            status.textContent = 'This variant is not currently available on ' + marketNames[market] + '.';
          }
        };

        marketButtons.forEach((button) => {
          button.addEventListener('click', () => {
            if (button.disabled) return;
            market = button.dataset.market;
            try {
              window.sessionStorage.setItem('si-amazon-market', market);
            } catch (error) {
              market = button.dataset.market;
            }
            update();
          });
        });

        section.addEventListener('change', () => window.setTimeout(update, 0));
        update();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize);
    } else {
      initialize();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
